import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import './studioTrialBanner.scss';
import studioTrialBannerView from './studioTrialBannerView.html';
let StudioTrialBannerComponent = class StudioTrialBannerComponent {
    constructor() {
        this.$onInit = () => {
            if (this.isEnabled === undefined) {
                this.isEnabled = true;
            }
        };
        this.$onChanges = (changes) => {
            if (changes.isEnabled && !changes.isEnabled.isFirstChange()) {
                this.isEnabled = changes.isEnabled.currentValue;
            }
        };
        this.handleStartPlan = () => {
            if (this.onStartPlan) {
                this.onStartPlan();
            }
        };
    }
};
StudioTrialBannerComponent = __decorate([
    Component({
        template: studioTrialBannerView,
        controllerAs: '$ctrl',
        bindings: {
            isEnabled: '<',
            onStartPlan: '&',
        },
    }),
    __metadata("design:paramtypes", [])
], StudioTrialBannerComponent);
export { StudioTrialBannerComponent };
